import BossModel from "@/models/BossModel";
import Currency from "@/models/Currency/Currency";
import Day from "@/models/Product/Detail/Composition/Purchase/Concept/Day/Day";

export default class Concept extends BossModel {

    static apiUrl = 'product/detail/composition/purchase/concept';

    static entity = 'productDetailCompositionPurchaseConcepts';

    static fields() {
        return {
            id: this.number(null).nullable(),
            product_detail_composition_id: this.number(null).nullable(),
            product_price_extension_element_id: this.number(null).nullable(),
            start_date_at: this.attr(null),
            end_date_at: this.attr(null),
            currency_id: this.number(null),
            adult: this.number(null).nullable(),
            child: this.number(null).nullable(),
            baby: this.number(null).nullable(),
            code: this.attr(null),
            is_active: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            unpublished: this.boolean(null),
            comment: this.attr(null),
            currency: this.belongsTo(Currency, 'currency_id'),
            days: this.hasMany(Day, 'product_detail_composition_purchase_concept_id'),
        }
    }
}
